import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    content: String,
  };

  static targets = ["copyDisplay", "postCopyDisplay"];

  copy() {
    if (this.hasContentValue) {
      navigator.clipboard.writeText(this.contentValue);
    }

    if (this.hasPostCopyDisplayTarget) {
      this.postCopyDisplayTarget.classList.remove("d-none");
    }

    if (this.hasCopyDisplayTarget) {
      this.copyDisplayTarget.classList.add("d-none");
    }
  }
}
